// extracted by mini-css-extract-plugin
export var emptyState = "_69-d";
export var statCard = "_69-c";
export var table = "_69-0";
export var tableCell = "_69-4";
export var tableCellClickable = "_69-5 _69-4";
export var tableCellDefault = "_69-6 _69-4";
export var tableCellEmpty = "_69-8";
export var tableCellWithValue = "_69-7";
export var tableContainer = "_69-e";
export var tableHeaderWeight = "_69-1";
export var tableHeaderZone = "_69-2";
export var tableRowHeader = "_69-3";
export var viewModeButton = "_69-9";
export var viewModeButtonActive = "_69-a _69-9";
export var viewModeButtonInactive = "_69-b _69-9";